export const NovaMark = ({ size = 40, dark = true }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true">
    <circle cx="20" cy="20" r="17" fill={dark ? "#0A192F" : "#FFFFFF"} />
    <path
      d="M20 8.5l2.7 8.8 8.8 2.7-8.8 2.7L20 31.5l-2.7-8.8-8.8-2.7 8.8-2.7z"
      fill={dark ? "#FFFFFF" : "#0A192F"}
    />
    <ellipse
      cx="20"
      cy="20"
      rx="18.5"
      ry="7"
      stroke="#2563EB"
      strokeWidth="1.6"
      fill="none"
      transform="rotate(-24 20 20)"
    />
  </svg>
);

export const LogoImage = () => (
  <a href="#top" data-testid="brand-logo" className="flex items-center group">
    <img
      src="/nova-logo-original.png"
      alt="NOVA OPSIS — A New Way Forward."
      className="h-[72px] sm:h-24 lg:h-28 w-auto select-none"
      draggable={false}
    />
  </a>
);

export const NovaLogo = ({ inverted = false }) => (
  <a href="#top" data-testid="brand-logo" className="flex items-center gap-3 group">
    <NovaMark size={42} dark={!inverted} />
    <span className="leading-none">
      <span
        className={`block text-[19px] font-extrabold tracking-tight ${
          inverted ? "text-white" : "text-nova-navy"
        }`}
      >
        NOVA OPSIS
      </span>
      <span className="block mt-1 text-[9px] font-semibold tracking-[0.32em] text-nova-blue">
        A NEW WAY FORWARD.
      </span>
    </span>
  </a>
);
